export enum HorseCategoryEnum {
    Foal = "Foal",
    Yearling = "Yearling",
    TwoYORacehorse = "2YO Racehorse",
    ThreeYORacehorse = "3YO Racehorse",
    OlderRacehorse = "Older Racehorse"
}